var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Browse'),_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-2 is-parent"},[_c('div',{staticClass:"tile is-child"},[_c('Filters')],1)]),_c('div',{staticClass:"tile is-parent"},[_c('div',{staticClass:"tile is-child"},[_c('TeaTable')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }